/* eslint-disable*/
import {
  Box,
  Dialog,
  Typography,
  DialogContent,
  Link
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkSurvey,
  displayFlag,
  onceOpened,
  error,
  loading,
  setDisplayFlag,
  setOnceOpenedFlag
} from 'feactures/survey/surveySlice';
import { Link as RouterLink } from 'react-router-dom';
import { userinfo } from 'feactures/user/userSlice';

const NoticeDialog = () => {
  const openFlag = useSelector(displayFlag);
  const onceOpenedFlag = useSelector(onceOpened);
  const userInfo = useSelector(userinfo);
  const trialStatus = userInfo.trial;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!onceOpenedFlag) {
      //初回レンダリング時のみ起動（閉じた後にチャンネルを移動しても表示されないように）
      dispatch(setOnceOpenedFlag);
    } else {
      return;
    }
  }, []);

  // ×ボタンクリックでポップアップを非表示にする。
  const handleClick = () => {
    dispatch(setDisplayFlag(false));
  };

  // 時刻部分を00:00:00にリセットする関数
  const resetTime = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  // 日本語形式で日付をフォーマットする関数
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}月${day}日`;
  };

  const today = resetTime(new Date());

  const idList = [
    1, 10, 12, 13, 15, 16, 18, 19, 20, 21, 23, 24, 25, 27, 28, 29, 32, 33, 34,
    35, 36, 37, 38, 39, 40, 43, 44, 45, 47, 51, 53, 54, 55, 56, 61, 62, 63, 65,
    66, 69, 70, 71, 74, 75, 77, 79, 80, 81, 82, 85, 87, 88, 89, 90, 91, 94, 95,
    96, 100, 101, 102, 104, 105, 106, 108, 109, 110, 111, 115, 118, 120, 121,
    122, 123, 124, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
    138, 139, 140, 141, 142, 143, 144, 145, 146, 148, 150, 151, 152, 153, 154,
    155, 156, 157, 158, 159, 160, 161, 162, 163, 165, 166, 167, 168, 169, 170,
    171, 172, 173, 174, 175, 176, 177, 178, 180, 181, 183, 184, 185, 186, 187,
    191, 192, 193, 194, 195, 196, 197, 199, 202, 205, 206, 207, 209, 211, 220,
    222, 223, 224, 227, 232, 233, 234, 235, 237, 238, 239, 240, 242, 245, 246,
    247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261,
    262, 263, 264, 266, 267, 268, 269, 270, 271, 272, 274, 275, 276, 278, 279,
    280, 281, 282, 284, 285, 287, 288, 289, 290, 291, 292, 294, 295, 296, 299,
    300, 304, 305, 306, 307, 309, 310, 311, 313, 315, 316, 317, 318, 319, 320,
    321, 322, 323, 324, 326, 327, 329, 331, 332, 333, 336, 337, 338, 345, 346,
    349, 350, 351, 352, 354, 355, 356, 358, 360, 363, 364, 365, 367, 369, 371,
    373, 374, 376, 377, 379, 381, 383, 384, 385, 387, 388, 389, 390, 391, 393,
    395, 396, 397, 398, 399, 400, 405, 406, 409, 411, 412, 413, 414, 415, 416,
    417, 418, 419, 422, 423, 424, 425, 430, 431, 432, 433, 435, 438, 440, 442,
    443, 444, 445, 446, 447, 448, 449, 450, 452, 454, 455, 457, 458, 459, 460,
    462, 463, 464, 465, 466, 467, 468, 469, 471, 474, 475, 476, 478, 479, 480,
    481, 482, 483, 484, 486, 487, 489, 490, 491, 492, 495, 496, 497, 498, 499,
    500, 501, 502, 503, 508, 509, 510, 511, 513, 514, 515, 516, 518, 519, 520,
    523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 535, 536, 537, 539,
    540, 542, 543, 545, 549, 550, 553, 554, 555, 556, 557, 558, 559, 560, 562,
    563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573, 574, 576, 577, 578,
    579, 580, 581, 582, 584, 585, 586, 587, 589, 592, 593, 594, 595, 596, 597,
    599, 601, 602, 603, 604, 605, 606, 607, 608, 609, 611, 612, 613, 614, 615,
    617, 618, 619, 620, 621, 622, 623, 626, 627, 628, 629, 630, 632, 633, 634,
    635, 636, 637, 638, 639, 640, 641, 642, 644, 645, 647, 648, 649, 650, 651,
    652, 653, 654, 655, 656, 657, 659, 660, 661, 663, 664, 665, 666, 667, 668,
    669, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 684,
    685, 686, 687, 688, 689, 690, 691, 693, 694, 695, 696, 698, 699, 700, 701,
    702, 703, 704, 705, 706, 707, 708, 709, 711, 713, 714, 715, 717, 718, 719,
    720, 721, 723, 724, 725, 727, 728, 729, 730, 731, 732, 733, 734, 735, 737,
    738, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752, 753,
    754, 756, 757, 758, 759, 760, 761, 762, 764, 765, 766, 767, 768, 771, 772,
    773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787,
    788, 789, 790, 791, 792, 793, 794, 795, 796, 798, 799, 800, 801, 802, 803,
    804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818,
    819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 833, 834,
    835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 849, 850,
    852, 853, 854, 855, 857, 858, 859, 860, 861, 862, 863, 864, 866, 868, 869,
    870, 871, 872, 873, 874, 875, 876, 877, 878, 882, 883, 885, 886, 887, 888,
    889, 890, 891, 892, 893, 894, 895, 896, 897, 898, 899, 900, 901, 902, 903,
    904, 905, 906, 907, 909, 910, 911, 912, 913, 915, 916, 918, 919, 920, 921,
    922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937,
    939, 940, 941, 942, 944, 945, 947, 948, 951, 952, 953, 954, 955, 956, 957,
    958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 972, 974, 975,
    976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990,
    991, 992, 993, 994, 995, 996, 997, 998, 1000, 1001, 1002, 1003, 1004, 1005,
    1006, 1007, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1020, 1021,
    1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033,
    1034, 1035, 1036, 1039, 1040, 1041, 1044, 1046, 1048, 1049, 1050, 1051,
    1052, 1053, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064,
    1065, 1066, 1067, 1072, 1074, 1075, 1077, 1079, 1080, 1082, 1083, 1084, 1086
  ];

  let a_id_flag;
  if (idList.includes(userInfo.accountId)) {
    a_id_flag = true;
  } else {
    a_id_flag = false;
  }

  return (
    <>
      {openFlag && (
        <Dialog open={openFlag} onClose={handleClick} maxWidth="700px">
          <DialogContent
            sx={{
              display: 'flex',
              padding: '20px 20px',
              bgcolor: userInfo.trial.trial_notice ? '#FFE4DC' : '#FFF8E5'
            }}
          >
            {userInfo.trial.trial_notice && (
              <Box
                sx={{ padding: '10px 10px' }}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                my={1}
                width="700px"
                height="350px"
              >
                <Box
                  m={1}
                  px={5}
                  py={8}
                  width="650px"
                  height="300px"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="#FFFFFF"
                >
                  <Typography fontSize={30} fontWeight="bold" mb={1}>
                    トライアルプランをご利用中です！
                  </Typography>
                  {Object.entries(trialStatus)
                    .filter(([mall, info]) => {
                      if (!info.end_date) return false;
                      const endDate = new Date(info.end_date);
                      return info.trial && endDate >= today;
                    })
                    .map(([mall, info]) => {
                      const endDate = new Date(info.end_date);
                      const remainingDays = Math.ceil(
                        (endDate - today) / (1000 * 60 * 60 * 24)
                      );

                      return (
                        <Box
                          key={mall}
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography fontSize={25} fontWeight="bold" mb={2}>
                            モール：{mall}
                          </Typography>
                          <Typography fontSize={35} fontWeight="bold" mb={1}>
                            残り{remainingDays}日
                          </Typography>
                          <Typography fontSize={20} fontWeight="bold" mb={1}>
                            {formatDate(endDate)} 23:59まで
                          </Typography>
                        </Box>
                      );
                    })}
                </Box>
              </Box>
            )}
            {userInfo.trial.advertise && (
              <Box
                sx={{ padding: '10px 10px' }}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                my={1}
                width="800px"
                height="350px"
              >
                <Box
                  m={1}
                  px={2}
                  py={8}
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="#FFFFFF"
                >
                  <Typography fontSize={27} fontWeight="bold" mb={1}>
                    トライアルのご利用ありがとうございました。
                  </Typography>
                  <Typography fontSize={27} fontWeight="bold" mb={1}>
                    この機会にぜひ有料プランへの切り替えをお願いします。
                  </Typography>
                  <Typography fontSize={24} fontWeight="bold" mb={1}>
                    有料プラン：5万円(税抜)/月
                  </Typography>
                  <Typography fontSize={24} fontWeight="bold" mb={1}>
                    有料プランへの切り替えは
                    <Link
                      component="a"
                      target="_blank"
                      rel="noopener noreferrer"
                      fontSize={24}
                      href="https://www.oxcim.net/plan-change"
                    >
                      こちら
                    </Link>
                  </Typography>
                </Box>
              </Box>
            )}
            {userInfo.trial.楽天.end_date === '' && a_id_flag && (
              <Box
                sx={{ padding: '10px 10px' }}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                my={1}
                width="700px"
                height="350px"
              >
                <Box
                  m={1}
                  px={2}
                  py={8}
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="#FFFFFF"
                  width="650px"
                  height="300px"
                >
                  <Typography fontSize={35} fontWeight="bold" mb={1}>
                    期間限定！
                  </Typography>
                  <Typography fontSize={30} fontWeight="bold" mb={1}>
                    楽天マーケットビュー機能
                  </Typography>
                  <Typography fontSize={30} fontWeight="bold">
                    1週間使い放題トライアル実施中！
                  </Typography>
                </Box>
              </Box>
            )}
            <CloseIcon
              onClick={handleClick}
              sx={{ alignSelf: 'flex-start', cursor: 'pointer' }}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default NoticeDialog;
